import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { SELLERS_BASE_URL, apiErrorManagemnt } from '../../api/Custom';
import Swal from 'sweetalert2';
import ShieldIcon from '@mui/icons-material/Shield';
import { getToken } from '../../custome/action';
import { Button } from '@mui/material';
import { DASHBOARD_BASE_PATH } from '../../custome/constants';

const SPAPIAuthorization = () => {
  const [error, setError] = useState('');
  const [isSuccess,setIsSuccess]=useState(false)
  const location = useLocation();
  const navigate = useNavigate()

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    
    // Amazon sends different parameter names: amazon_state and amazon_callback_uri
    const amazonState = params.get("amazon_state") || params.get("state");
    const amazonCallbackUri = params.get('amazon_callback_uri') || params.get('spapi_oauth_code');
    const sellingPartnerId = params.get('selling_partner_id');

    const fetchTokens = async () => {
      try {
        if (!amazonState || !amazonCallbackUri) {
          setError("Missing authorization parameters from Amazon");
          Swal.fire('ERROR', 'Missing authorization parameters', 'error');
          return;
        }

        // Extract channelId from state (format: uuid~channelId)
        const stateArray = amazonState.split("~");
        const channelId = stateArray.length > 1 ? stateArray[1] : null;
        
        if (!channelId) {
          setError("Channel ID not found in state parameter");
          Swal.fire('ERROR', 'Channel ID not found', 'error');
          return;
        }

        // Extract the authorization code from amazon_callback_uri if it's a full URI
        // Format: https://sellercentral.amazon.in/apps/authorize/confirm/[app-id]?[code]=[value]
        let authCode = amazonCallbackUri;
        if (amazonCallbackUri && amazonCallbackUri.includes('?')) {
          const uriParams = new URLSearchParams(amazonCallbackUri.split('?')[1]);
          authCode = uriParams.get('spapi_oauth_code') || amazonCallbackUri;
        }

        const url=`${SELLERS_BASE_URL}/generateAmazonTokens?spapi_oauth_code=${encodeURIComponent(authCode)}&channelId=${channelId}`;
        
        await axios.get(url, {
          headers: {
            'Authorization': 'Bearer ' + getToken(),
            'Content-Type': 'application/json'
          }
        }).then(
          (response) => {
            if (response?.data?.status === 0) {
              setIsSuccess(true)
              Swal.fire('Success', response?.data?.message, 'success')
            }else{
              setIsSuccess(false);
              setError(response?.data?.message);
              Swal.fire('ERROR', response?.data?.message, 'error');
            }
          },
          (error) => {
            setIsSuccess(false);
            setError(JSON.stringify(error))
            return error;
          }
        ).catch(err => {
          return (err)
        });

      } catch (error) {
        setIsSuccess(false)
        setError('Error fetching tokens: ' + error.message);
        Swal.fire('ERROR', 'Error fetching tokens', 'error');
      }
    };

    if (amazonCallbackUri) {
      fetchTokens();
    } else {
      setError("Authorization code not present in response from Amazon")
    }
  }, [location.search]);

  return (
    <div>
      {isSuccess ? (
        <div className='alert alert-light text-center m-5'>
          <ShieldIcon color="success" style={{width:"50px", height:"50px"}} />
           <h5 className='py-4'>ManageEcom Authorization successful! Your new access token and refresh token have been generated.</h5>
            <Button size="small" variant='contained' onClick={()=>{navigate(DASHBOARD_BASE_PATH)}} > Back To Dashboard</Button>
        </div>
      ) : (
        <h6 className='text-center my-3'>{error || 'Loading...'}</h6>
      )}
    </div>
  );
};

export default SPAPIAuthorization;
